import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import {
  buildMerchantInfoForPreview,
  getNotReturnableReason,
  mapProductToLineItem,
} from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/BlockedProductsPreview/helpers'
import inventoryServices from '@/inventory/services/services'

const useBlockedProductsPreview = ({ activeBlockedProduct, customCopies, lang, merchantInfo }) => {
  const { info } = useContext(AppContext)
  const storeId = info?.selectedStore?.id

  const { data: productsResponse, loading } = useFetch(inventoryServices.getProductsInventoryItems, {
    doInitialRequest: !!storeId,
    params: { storeId },
  })

  const firstProduct = productsResponse?.results?.[0]
  const lineItem = mapProductToLineItem(firstProduct)
  const notReturnableReason = getNotReturnableReason(activeBlockedProduct)
  const previewMerchantInfo = buildMerchantInfoForPreview(customCopies, lang, merchantInfo)

  return { lineItem, notReturnableReason, previewMerchantInfo, loading }
}

export default useBlockedProductsPreview
